import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { LoginForgerockComponent } from './components/login-forgerock/login-forgerock.component';
import { CallbackComponent } from './components/login-forgerock/callback.component';
import { ConsentGrantedStateComponent } from './components/dashboard/consent-granted-state/consent-granted-state.component';

export const routes: Routes = [
  {path: "", redirectTo: "home", pathMatch: 'full'},
  {path: "login", component: LoginForgerockComponent},
  {path: "authredirect", component: CallbackComponent},
  {
    path: "home", canActivate: [AuthGuard], component: ConsentGrantedStateComponent
  },
  {path: "**", redirectTo: "home"}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
